import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginModule } from './modulos/login/login.module';
import { NavigationModule } from './modulos/navigation/navigation.module';
//
// import { MenuModule } from './entidades/menu/menu.module';

const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'login' },
  {
    path: 'login',
    loadChildren: () => LoginModule,
  },
  {
    path: 'bienvenida',
    title: 'Bienvenida',
    loadComponent: () =>
      import('./modulos/bienvenida/bienvenida.component').then(
        (m) => m.BienvenidaComponent,
      ),
  },
  {
    path: 'main',
    // canActivate: [LoginGuard],
    loadChildren: () => NavigationModule,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
